import { render } from "./CustomersTable.vue?vue&type=template&id=fa676c56&scoped=true"
import script from "./CustomersTable.vue?vue&type=script&lang=js"
export * from "./CustomersTable.vue?vue&type=script&lang=js"

import "./CustomersTable.vue?vue&type=style&index=0&id=fa676c56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa676c56"]])

export default __exports__